import React from 'react'

const ViewField = ({ label, body = null, value = null, className = null, style = null, labelClassName = 'col-4', valueClassName = 'col-8' }) => {
    return (
        <div className={`${className} grid`} style={style}>
            <div className={`${labelClassName} pt-3`}><div className='pt-1'>{label}</div></div>
            <div className={`${valueClassName}`}>
                <div className='p-inputtext p-component p-filled'>
                    {body ? body() : value} &nbsp;
                </div>
            </div>
        </div>
    )
}

export default ViewField